var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as types from './types';
import * as statuses from '../../states';
var initialState = {
    status: statuses.IDLE,
    step: 'legal',
    id: 0,
    legal: {
        registration: 'string',
        name: 'string',
        address: 'string',
        zipCode: 'string',
        city: 'string',
        country: 'string',
    },
    bank: {
        bankAccount: '',
        routing_number: '',
        bank_country: '',
    },
    document: {},
    acctStripe: {
        status: statuses.IDLE,
        valid: false,
    },
};
export default function societyReducer(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.FETCH_SOCIETY_REQUEST:
            return __assign(__assign({}, state), { status: statuses.IDLE });
        case types.FETCH_SOCIETY_SUCCEEDED:
            return __assign(__assign(__assign({}, state), { status: statuses.SUCCESS }), payload);
        case types.FETCH_SOCIETY_FAILED:
            return __assign(__assign({}, state), { status: statuses.FAIL });
        case types.UPDATE_SOCIETY_REQUEST:
            return __assign(__assign({}, state), { status: statuses.LOADING });
        case types.UPDATE_SOCIETY_SUCCEEDED:
            return __assign(__assign(__assign({}, state), payload), { status: statuses.SUCCESS });
        case types.UPDATE_SOCIETY_FAILED:
            return __assign(__assign({}, state), { status: statuses.FAIL });
        case types.UPLOAD_SOCIETY_DOCUMENT_REQUEST:
            return __assign(__assign({}, state), { status: statuses.LOADING });
        case types.UPLOAD_SOCIETY_DOCUMENT_SUCCEED:
            if (payload === undefined || !('name' in payload))
                return;
            if (payload.name === 'rib') {
                return __assign(__assign({}, state), { status: statuses.SUCCESS, bank: __assign(__assign({}, state.bank), (_a = {}, _a[payload.name] = __assign(__assign({}, (state.bank && state.bank[payload.name] || {})), { status: 'SUCCESS', link: payload.link }), _a)) });
            }
            return __assign(__assign({}, state), { status: statuses.SUCCESS, document: __assign(__assign({}, state.document), (_b = {}, _b[payload.name] = __assign(__assign({}, (state.document && state.document[payload.name] || {})), { status: 'SUCCESS', link: payload.link }), _b)) });
        case types.UPLOAD_SOCIETY_DOCUMENT_FAILED:
            if (payload === undefined || !('name' in payload))
                return;
            if (payload.name === 'rib') {
                return __assign(__assign({}, state), { status: statuses.FAIL, bank: __assign(__assign({}, state.bank), (_c = {}, _c[payload.name] = __assign(__assign({}, (state.bank && state.bank[payload.name] || {})), { status: statuses.FAIL, link: payload.link }), _c)) });
            }
            return __assign(__assign({}, state), { status: statuses.FAIL, document: __assign(__assign({}, state.document), (_d = {}, _d[payload.name] = __assign(__assign({}, (state.document && state.document[payload.name] || {})), { status: statuses.FAIL, link: payload.link }), _d)) });
        case types.SET_SOCIETY_STEP:
            return __assign(__assign({}, state), { step: payload });
        case types.GET_ACCT_STATUS_REQUEST:
            return __assign(__assign({}, state), { acctStripe: __assign(__assign({}, state.acctStripe), { status: statuses.LOADING }) });
        case types.GET_ACCT_STATUS_SUCCEED:
            if (payload === undefined || !('valid' in payload))
                return;
            return __assign(__assign({}, state), { acctStripe: __assign(__assign({}, state.acctStripe), { status: statuses.SUCCESS, valid: payload.valid }) });
        case types.GET_ACCT_STATUS_FAILED:
            return __assign(__assign({}, state), { acctStripe: __assign(__assign({}, state.acctStripe), { status: statuses.FAIL }) });
        default:
            return state;
    }
}
